import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class NafathWindowService {
    nafathWindow: Window | null = null;
}
